import React from 'react';
import classNames from 'classnames';
import useTestTypeFeatures from 'src/shared/hooks/useTestTypeFeatures';
import styles from './SpeciesTags.module.scss';

type SpeciesTagsProps = {
    iucnStatusType: string;
    isInvasive: boolean;
    iucnStatusLabel: string;
    chegdGroup: string;
    shortedLabel?: boolean;
};

const SpeciesTags = (props: SpeciesTagsProps) => {
    const { iucnStatusType, isInvasive, iucnStatusLabel, shortedLabel = false, chegdGroup } = props;
    const { hasProjectLevelIucnRedlistFeature, hasProjectLevelInvasivesFeature, hasProjectLevelChegdFeature } = useTestTypeFeatures();

    return (
        <>
            {hasProjectLevelIucnRedlistFeature && iucnStatusType && (
                <span className={classNames([styles.chip, styles[iucnStatusType]])}>{iucnStatusLabel}</span>
            )}
            &nbsp;
            {hasProjectLevelInvasivesFeature && isInvasive && (
                <span className={classNames([styles.chip, styles.invasive])}>{shortedLabel ? 'INV' : 'Invasive'}</span>
            )}
            {hasProjectLevelChegdFeature && chegdGroup && (
                <span className={classNames([styles.chip, styles.chegd])}>{shortedLabel ? chegdGroup[0] : chegdGroup}</span>
            )}
        </>
    );
};

export default SpeciesTags;
